import React, { memo } from 'react';
import { Line } from 'react-chartjs-2';

import './chart-setup';
import { UI } from '../../styled-comps';

// Multi-line chart, typically conversion percentages. `datasets` = [{ label, data, color }].
const ConversionLineChart = memo(({ labels, datasets, suffix = '%' }) => {
  const data = {
    labels,
    datasets: datasets.map(ds => ({
      label: ds.label,
      data: ds.data,
      borderColor: ds.color,
      backgroundColor: 'transparent',
      fill: false,
      tension: 0.4,
      pointRadius: 3,
      pointHoverRadius: 5,
      borderWidth: 2,
      spanGaps: true,
    })),
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: { usePointStyle: true, pointStyleWidth: 8, padding: 16 },
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        callbacks: {
          label: ctx => ` ${ctx.dataset.label}: ${ctx.parsed.y}${suffix}`,
        },
      },
    },
    scales: {
      x: { grid: { display: false }, ticks: { maxRotation: 40, minRotation: 40 } },
      y: {
        beginAtZero: true,
        grid: { color: UI.borderLight },
        ticks: { callback: value => `${value}${suffix}` },
      },
    },
  };

  return <Line data={data} options={options} />;
});

export default ConversionLineChart;
